import React from 'react';
import AdminTempMonitor from '../admin-temp-monitor';
const JKHiveTempMonitor = () => <AdminTempMonitor />;
export default JKHiveTempMonitor;
